import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Grid, IconButton, Tooltip } from '@material-ui/core';
import Card from '../../Card/Card.js';
import CardBody from '../../Card/CardBody.js';
import HomeIcon from '@material-ui/icons/Home';
import PrintIcon from '@material-ui/icons/Print';
import HelpIcon from '@material-ui/icons/Help';
import HousingTradelifeIcon from '../../../assets/img/planner-housing-tradelife-icon.svg';
import AftercareApp from '../../Aftercare/AftercareApp';
import { useReactToPrint } from 'react-to-print';
import { initialAftercareFormState } from '../../../constants/initialAftercareFormState';
import { isStudent, isAlumni } from '../../../util/miscUtil';

const Aftercare = ({
  senior,
  alumni,
  roles,
  handleHelp,
  store,
  auth,
  handleAfterSaveReturn,
  setPage,
  handleReturnToSeniorList,
  classes,
  handleGotoAdminHomepage,
}) => {
  const componentRef = useRef();

  const [form, setForm] = useState(initialAftercareFormState);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <React.Fragment>
      {!isStudent(roles) && !isAlumni(roles) && (
        <Grid container direction="row" className={classes.unprintedContent}>
          <Grid item xs={12}>
            <div className={classes.breadcrumbs}>
              <Breadcrumbs separator="›" aria-label="breadcrumbs" className={classes.alignCrumb}>
                <span className={classes.breadCrumbLink} onClick={() => handleGotoAdminHomepage()}>
                  <HomeIcon style={{ fontSize: '1.30rem' }} />
                  <span style={{ margin: '1px 0 0 1px' }}>Home</span>
                </span>
                <span className={classes.breadCrumbLink} onClick={() => handleReturnToSeniorList()}>
                  {alumni ? 'Alumni' : 'High School Seniors'}
                </span>
                <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={() => setPage('home')}>
                  {senior && senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
                  {senior && senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
                </span>
                <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={() => setPage('aftercareapps')}>
                  Community Supports/Housing Applications
                </span>
                <span className={classes.breadCrumbText} style={{ marginTop: '-1px' }}>
                  Application
                </span>
              </Breadcrumbs>
            </div>
          </Grid>
        </Grid>
      )}
      <Grid container spacing={2} direction="row" className={classes.menu} ref={componentRef}>
        <Grid item xs={12} align="left" className={classes.unprintedContent}>
          <Card className={classes.pageHeader}>
            <CardBody className={classes.headerCard}>
              <Grid container direction="row">
                <Grid item xs={10} align="left">
                  <section className={classes.pageTitle}>
                    <img src={HousingTradelifeIcon} alt="Community Supports and Housing Icon" className={classes.pageIcon} />
                    <span className={classes.pagecardHeader}>Community Supports/Housing Application</span>
                  </section>
                  <aside className={classes.headerDesc}>
                    Please enter the information below and complete a {form?.version === 2 ? '1000' : '500'}-word essay to apply for{' '}
                    <em>Successful Futures - Community Supports</em> and <em>Successful Futures - Housing</em>.
                  </aside>
                </Grid>
                <Grid item xs={2} align="right">
                  <Tooltip title="Click to return to the planner home page." placement="bottom">
                    <IconButton color="inherit" aria-label="return home" onClick={() => setPage('home')}>
                      <HomeIcon className={classes.homeIcon} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Click to return to open the printer dialog." placement="bottom">
                    <IconButton color="inherit" aria-label="print Community Supports/Housing application" onClick={handlePrint}>
                      <PrintIcon className={classes.homeIcon} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Click to return to view printer tips & tricks." placement="bottom">
                    <IconButton color="inherit" aria-label="printer tips and tricks" onClick={handleHelp}>
                      <HelpIcon className={classes.homeIcon} />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </CardBody>
          </Card>
        </Grid>
        <Grid item xs={12} align="left" className={classes.printedContent}>
          <section className={classes.pageTitle}>
            <span className={classes.printHeaderText}>Community Supports/Housing Application</span>
          </section>
          <aside className={classes.printHeaderDesc}>
            Please enter the information below and complete a {form?.version === 2 ? '1000' : '500'}-word essay to apply for{' '}
            <em>Successful Futures - Community Supports</em> and <em>Successful Futures - Housing</em> programs.
          </aside>
        </Grid>
        <Grid item xs={12}>
          <AftercareApp SeniorStore={store} AuthStore={auth} handleSaveReturn={handleAfterSaveReturn} form={form} setForm={setForm} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

Aftercare.propTypes = {
  senior: PropTypes.object,
  alumni: PropTypes.bool,
  roles: PropTypes.array,
  handleHelp: PropTypes.func,
  store: PropTypes.object,
  auth: PropTypes.object,
  handleAfterSaveReturn: PropTypes.func,
  setPage: PropTypes.func,
  handleReturnToSeniorList: PropTypes.func,
  classes: PropTypes.object.isRequired,
  handleGotoAdminHomepage: PropTypes.func.isRequired,
};

export default Aftercare;
